import {
    Divider,
    Paper,
    Typography
} from "@mui/material";
import {
    useCallback,
    useState
} from "react";

import Box from "@mui/material/Box";
import { CognitoUser } from "amazon-cognito-identity-js";
import { ForceNewPasswordForm } from "./ForceNewPasswordForm";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { SignInForm } from "./SignInForm";
import { SignUpConfirmationForm } from "./SignUpConfirmationForm";

export const SignInPage = () => {
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [showConfirmationPage, setShowConfirmationPage] = useState<boolean>(false);
    const [showForgotPasswordPage, setShowForgotPasswordPage] = useState<boolean>(false);
    const [forceNewPasswordUser, setForceNewPasswordUser] = useState<CognitoUser | undefined>(undefined);

    const assignEmailAndShowConfirmationPage = useCallback((email: string) => {
        //ensure the user redirects to landing page for initial sign in
        window.history.pushState({}, "", "/");
        setShowConfirmationPage(true);
        setEmail(email);
    }, []);

    return (
        <Box
            height="100vh"
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Paper sx={{ py: 1, m: 2 }} variant="outlined">
                {showConfirmationPage && email != undefined ?
                    <SignUpConfirmationForm
                        email={email!}
                    /> :
                    showForgotPasswordPage ?
                        <ForgotPasswordForm
                            onBackToSignInPage={() => setShowForgotPasswordPage(false)}
                        /> :
                        forceNewPasswordUser ?
                            <ForceNewPasswordForm
                                user={forceNewPasswordUser}
                            /> :
                            <>
                                <Typography
                                    variant="h4"
                                    align="center"
                                    sx={{
                                        color: "primary.main",
                                        pt: 2
                                    }}
                                >
                                    Sign In
                                </Typography>
                                <Typography
                                    variant="subtitle1"
                                    align="center"
                                    sx={{
                                        pb: 2
                                    }}
                                >
                                    to continue to Tenera
                                </Typography>
                                <Divider />
                                <SignInForm
                                    onUserNotConfirmed={assignEmailAndShowConfirmationPage}
                                    onForgotPassword={() => setShowForgotPasswordPage(true)}
                                    onForceNewPassword={(user: CognitoUser) => setForceNewPasswordUser(user)}
                                />
                            </>
                }
            </Paper>
        </Box>
    );
};